import Vue from "vue";
import VueRouter from "vue-router";
import Element from "element-ui";
import store from '@/store/index.js'

Vue.use(VueRouter);

//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
//push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
	return originalPush.call(this, location).catch(err => err)
}
//replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
	return originalReplace.call(this, location).catch(err => err)
}

import Home from "../views/home.vue";

// 课题申报=>课题申报=>项目列表
const topicsDeclaration = [{
		path: '/backstage/topicsDeclaration',
		meta: {
			title: '课题通知列表'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/topicsDeclaration/topicsDeclaration.vue'),
	},
	// 课题申报=>课题申报=>创建新项目
	{
		path: '/backstage/newProject',
		meta: {
			title: '发布课题申报通知'
		},
		component: () => import('../views/backstage/topicsDeclaration/topicsDeclaration/newProject.vue')
	},
	// 课题申报=>课题申报=>课题申报列表
	{
		path: '/backstage/topicsList',
		meta: {
			title: '课题申报列表',
			isProjectName: true
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/topicsDeclaration/projectApplicationList.vue')
	},
	// 课题申报=>课题申报=>课题申报流程
	{
		path: '/backstage/projectApplicationProcess',
		meta: {
			title: '课题申报流程'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/topicsDeclaration/projectApplicationProcess.vue')
	},
	// 课题申报=>课题申报=>课题审核意见
	{
		path: '/backstage/reviewOpinion',
		meta: {
			title: '课题申报流程'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/topicsDeclaration/reviewOpinion.vue')
	},
]
const schoolTopicList = [
	// 课题申报=>学校审核=>学校课题列表
	// {
	// 	path: '/backstage/schoolTopicList',
	// 	meta: {
	// 		title: '学校课题列表'
	// 	},
	// 	component: () => import(
	// 		'../views/backstage/topicsDeclaration/projectReview/schoolTopicList.vue')
	// },
	// 课题申报=>学校审核=>学校审核列表
	{
		path: '/backstage/schoolTopicReviewList',
		meta: {
			title: '学校审核列表',
			isProjectName: true
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/projectReview/subjectAuditList.vue')
	},
	// 课题申报=>学校审核=>学校审核详情
	{
		path: '/backstage/schoolTopicReviewDetail',
		meta: {
			title: '学校审核详情'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/projectReview/subjectAuditDetail.vue')
	},
]
const areaTopicList = [
	// 课题申报=>区域审核=>区域课题列表
	// {
	// 	path: '/backstage/areaTopicList',
	// 	meta: {
	// 		title: '区域课题列表'
	// 	},
	// 	component: () => import(
	// 		'../views/backstage/topicsDeclaration/areaReview/areaTopicList.vue')
	// },
	// 课题申报=>区域审核=>区域审核列表
	{
		path: '/backstage/areaReviewList',
		meta: {
			title: '区域审核列表',
			isProjectName: true
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/areaReview/areaReviewList.vue'
		)
	},
	// 课题申报=>区域审核=>区域审核详情
	{
		path: '/backstage/areaReviewDetail',
		meta: {
			title: '区域审核详情'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/areaReview/areaReviewDetail.vue'
		)
	},
]
const declarationSummaryStatistics = [
	// 课题申报=>申报汇总统计=>申报汇总统计
	{
		path: '/backstage/declarationSummaryStatistics',
		meta: {
			title: '申报汇总统计',
			isProjectName: true
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/declarationSummaryStatistics/declarationSummaryStatistics.vue'
		)
	},
]
// 课题申报=>专家评审设置
const topicList = [
	// 课题申报=>专家评审设置=>专家评审课题列表
	{
		path: '/backstage/topicList',
		meta: {
			title: '专家评审课题列表'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/expertReviewSettings/topicList.vue')
	},
	// 课题申报=>专家评审设置=>专家评审列表
	{
		path: '/backstage/expertReviewList',
		meta: {
			title: '专家评审列表',
			isProjectName: true
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/expertReviewSettings/expertReviewList.vue')
	},
	// 课题申报=>专家评审设置=>专家评审设置
	{
		path: '/backstage/expertReviewSettings',
		meta: {
			title: '专家评审设置'
		},
		component: () => import(
			'../views/backstage/topicsDeclaration/expertReviewSettings/expertReviewSettings.vue')
	},
]
// 课题申报=>专家评分
const expertScoreList = [
	// 课题申报=>专家评分=>专家评分列表
	{
		path: '/backstage/expertScoreList',
		meta: {
			title: '专家评分列表'
		},
		component: () => import('../views/backstage/topicsDeclaration/expertScore/expertScoreList.vue')
	},
	// 课题申报=>专家评分=>专家待评审课题
	{
		path: '/backstage/notReviewTopics',
		meta: {
			title: '专家待评审课题'
		},
		component: () => import('../views/backstage/topicsDeclaration/expertScore/notReviewTopics.vue')
	},
	// 课题申报=>专家评分=>待评审课题详情
	{
		path: '/backstage/notReviewTopicsDetail',
		meta: {
			title: '待评审课题详情'
		},
		component: () => import('../views/backstage/topicsDeclaration/expertScore/notReviewTopicsDetail.vue')
	},
]
// 课题申报=>立项审核
const proposedProject = [
	// 课题申报=>立项审核
	{
		path: '/backstage/proposedProject',
		meta: {
			title: '立项审核'
		},
		component: () => import('../views/backstage/topicsDeclaration/projectStatus/proposedProject.vue')
	},
]
// 课题申报=>已立项
const approvedProject = [
	// 课题申报=>已立项
	{
		path: '/backstage/approvedProject',
		meta: {
			title: '已立项课题'
		},
		component: () => import('../views/backstage/topicsDeclaration/projectStatus/approvedProject.vue')
	},
]
// 系统管理=>用户管理
const userManagementList = [
	// 系统管理=>用户管理=>用户管理列表
	{
		path: '/backstage/userManagementList',
		meta: {
			title: '用户管理列表'
		},
		component: () => import('../views/backstage/systemManagement/userManagement/index.vue')
	},
	// 系统管理=>用户管理=>新建用户
	{
		path: '/backstage/addUser',
		meta: {
			title: '新建用户'
		},
		component: () => import('../views/backstage/systemManagement/userManagement/addUser.vue')
	},
]
// 系统管理=>文章发布
const articleManagement = [
	// 系统管理=>文章发布
	{
		path: '/backstage/articleManagement',
		meta: {
			title: '文章发布'
		},
		component: () => import('../views/backstage/systemManagement/articleManagement/index.vue')
	},
]
// 系统管理=>区域管理
const areaManagement = [
	// 系统管理=>区域管理
	{
		path: '/backstage/areaManagement',
		meta: {
			title: '区域管理'
		},
		component: () => import('../views/backstage/systemManagement/areaManagement/index.vue')
	},
]
// 系统管理=>单位管理
const unitManagement = [
	// 系统管理=>单位管理
	{
		path: '/backstage/unitManagement',
		meta: {
			title: '单位管理'
		},
		component: () => import('../views/backstage/systemManagement/unitManagement/index.vue')
	}
]

const roleAuthorization = [
	// 系统管理=>用户角色授权=>用户角色授权列表
	{
		path: '/backstage/roleAuthorization',
		meta: {
			title: '用户角色授权'
		},
		component: () => import('../views/backstage/systemManagement/roleAuthorization/index.vue')
	},
]
const platformInformationMaintenance = [
	// 系统管理=>平台信息维护=>平台信息维护
	{
		path: '/backstage/platformInformationMaintenance',
		meta: {
			title: '平台信息维护'
		},
		component: () => import('../views/backstage/systemManagement/platformInformationMaintenance/index.vue')
	},
]
// 课题管理--------------------------------------------------------------------------------------------------
// const myTopic = [
// 	// 课题管理=>负责的课题
// 	{
// 		path: 'myTopic',
// 		meta: {
// 			title: '负责的课题'
// 		},
// 		component: () => import('../views/backstage/topicManage/myTopic/myTopic.vue')
// 	},
// 	// 课题管理=>过程材料列表
// 	{
// 		path: 'processMaterialList',
// 		meta: {
// 			title: '过程材料列表'
// 		},
// 		component: () => import('../views/backstage/topicManage/myTopic/processMaterialList.vue')
// 	},
// 	// 课题管理=>课题变更申请
// 	{
// 		path: 'topicChangeApplication',
// 		meta: {
// 			title: '课题变更申请'
// 		},
// 		component: () => import('../views/backstage/topicManage/myTopic/topicChangeApplication.vue')
// 	},

// ]
// const topicSummary = [
// 	// 课题管理=>在研课题汇总
// 	{
// 		path: 'topicSummary',
// 		meta: {
// 			title: '在研课题汇总'
// 		},
// 		component: () => import('../views/backstage/topicManage/topicSummary/topicSummary.vue')
// 	},
// 	// 课题管理=>添加或者修改课题
// 	{
// 		path: 'addOrEditTopic',
// 		meta: {
// 			title: '创建课题'
// 		},
// 		component: () => import('../views/backstage/topicManage/topicSummary/addOrEditTopic.vue')
// 	},
// ]

const openReview = [
	// 课题管理=>开题审核
	{
		path: 'openReview',
		meta: {
			title: '开题审核'
		},
		component: () => import('../views/backstage/topicManage/openReview/openReview.vue')
	},
	// 课题管理=>开题审核=>校审核
	{
		path: 'openReviewSchoolReviewDetail',
		meta: {
			title: '开题校审核详情'
		},
		component: () => import('../views/backstage/topicManage/openReview/schoolReviewDetail.vue')
	},
	// 课题管理=>开题审核=>区审核
	{
		path: 'openReviewAreaReviewDetail',
		meta: {
			title: '开题区级审核详情'
		},
		component: () => import('../views/backstage/topicManage/openReview/areaReviewDetail.vue')
	},
]

const midtermReview = [
	// 课题管理=>中期审核
	{
		path: 'midtermReview',
		meta: {
			title: '中期审核'
		},
		component: () => import('../views/backstage/topicManage/midtermReview/midtermReview.vue')
	},
	// 课题管理=>中期审核=>校审核
	{
		path: 'midtermReviewSchoolReviewDetail',
		meta: {
			title: '中期校审核详情'
		},
		component: () => import('../views/backstage/topicManage/midtermReview/schoolReviewDetail.vue')
	},
	// 课题管理=>中期审核=>区审核
	{
		path: 'midtermReviewAreaReviewDetail',
		meta: {
			title: '中期区级审核详情'
		},
		component: () => import('../views/backstage/topicManage/midtermReview/areaReviewDetail.vue')
	},
]
const concludingApplication = [
	// 课题管理=>结题申请审核
	{
		path: 'concludingApplication',
		meta: {
			title: '结题申请审核'
		},
		component: () => import('../views/backstage/topicManage/concludingApplication/concludingApplication.vue')
	},
	// 课题管理=>结题申请审核=>校审核
	{
		path: 'concludingApplicationSchoolReviewDetail',
		meta: {
			title: '结题申请校审核详情'
		},
		component: () => import('../views/backstage/topicManage/concludingApplication/schoolReviewDetail.vue')
	},
	// 课题管理=>结题申请审核=>区审核
	{
		path: 'concludingApplicationAreaReviewDetail',
		meta: {
			title: '结题申请区级审核详情'
		},
		component: () => import('../views/backstage/topicManage/concludingApplication/areaReviewDetail.vue')
	},
]
const concludingReview = [
	// 课题管理=>结题审核
	{
		path: 'concludingReview',
		meta: {
			title: '结题审核'
		},
		component: () => import('../views/backstage/topicManage/concludingReview/concludingReview.vue')
	},
	// 课题管理=>结题审核=>校审核
	{
		path: 'concludingReviewSchoolReviewDetail',
		meta: {
			title: '结题校审核详情'
		},
		component: () => import('../views/backstage/topicManage/concludingReview/schoolReviewDetail.vue')
	},
	// 课题管理=>结题审核=>区审核
	{
		path: 'concludingReviewAreaReviewDetail',
		meta: {
			title: '结题区级审核详情'
		},
		component: () => import('../views/backstage/topicManage/concludingReview/areaReviewDetail.vue')
	},
]
const topicManageExpertReviewList = [
	// 课题管理=>专家评审设置=>专家评审列表
	{
		path: 'topicManageExpertReviewList',
		meta: {
			title: '专家评审列表'
		},
		component: () => import('../views/backstage/topicManage/expertReviewSettings/expertReviewList.vue')
	},
	// 课题管理=>专家评审设置=>专家评审设置
	{
		path: 'topicManageExpertReviewSettings',
		meta: {
			title: '专家评审设置'
		},
		component: () => import('../views/backstage/topicManage/expertReviewSettings/expertReviewSettings.vue')
	},
]
const quasiConcluding = [
	// 课题管理=>拟结题
	{
		path: 'quasiConcluding',
		meta: {
			title: '拟结题'
		},
		component: () => import('../views/backstage/topicManage/quasiConcluding/quasiConcluding.vue')
	},
]
const finishedTopic = [
	// 课题管理=>已结题
	{
		path: 'finishedTopic',
		meta: {
			title: '已结题'
		},
		component: () => import('../views/backstage/topicManage/finishedTopic/finishedTopic.vue')
	},
]
const topicChange = [
	// 课题管理=>课题变更
	{
		path: 'topicChange',
		meta: {
			title: '课题变更'
		},
		component: () => import('../views/backstage/topicManage/topicChange/topicChange.vue')
	},
]
const topicStat = [
	// 课题管理=>课题统计
	{
		path: 'topicStat',
		meta: {
			title: '课题统计'
		},
		component: () => import('../views/backstage/topicManage/topicStat/topicStat.vue')
	},
]
const topicManageReviewList = [
	// 课题管理=>专家评分=>评审列表
	{
		path: 'topicManageReviewList',
		meta: {
			title: '评审列表'
		},
		component: () => import('../views/backstage/topicManage/expertScore/reviewList.vue')
	},
	// 课题管理=>专家评分=>课题列表
	{
		path: 'topicManageTopicList',
		meta: {
			title: '课题列表'
		},
		component: () => import('../views/backstage/topicManage/expertScore/topicList.vue')
	},
	// 课题管理=>专家评分=>评审详情
	{
		path: 'topicManageReviewTopicDetail',
		meta: {
			title: '评审详情'
		},
		component: () => import('../views/backstage/topicManage/expertScore/reviewTopicDetail.vue')
	}
]

// 科研资源----------------------------------------------------------------------------------------------------------------------
const scientificResource = [
	// 科研资源-资源列表
	{
		path: 'scientificResource',
		meta: {
			title: '科研资源列表'
		},
		component: () => import('../views/backstage/scientificResource/scientificResource.vue')
	}
]

// 课题管理--------------------------------------------------------------------------------------------------
const myTopic = [
	// 课题管理=>负责的课题
	{
		path: 'myTopic',
		meta: {
			title: '负责的课题'
		},
		component: () => import('../views/backstage/topicManage/myTopic/myTopic.vue')
	},
	// 课题管理=>过程材料列表
	{
		path: 'processMaterialList',
		meta: {
			title: '过程材料列表'
		},
		component: () => import('../views/backstage/topicManage/myTopic/processMaterialList.vue')
	},
	// 课题管理=>课题变更申请
	{
		path: 'topicChangeApplication',
		meta: {
			title: '课题变更申请'
		},
		component: () => import('../views/backstage/topicManage/myTopic/topicChangeApplication.vue')
	},

]
const topicSummary = [
	// 课题管理=>在研课题汇总
	{
		path: 'topicSummary',
		meta: {
			title: '在研课题汇总'
		},
		component: () => import('../views/backstage/topicManage/topicSummary/topicSummary.vue')
	},
	// 课题管理=>添加或者修改课题
	{
		path: 'addOrEditTopic',
		meta: {
			title: '创建课题'
		},
		component: () => import('../views/backstage/topicManage/topicSummary/addOrEditTopic.vue')
	},
]

const mySubmitted = [
	//征文评审 => 我提交作品
	{
		path: 'mySubmitted',
		meta: {
			title: '个人提交'
		},
		component: () => import('../views/backstage/essayEvaluation/mySubmitted.vue')
	},
	{
		path: 'submitteAppraisal',
		meta: {
			title: '提交参评作品'
		},
		component: () => import('../views/backstage/essayEvaluation/submitteAppraisal.vue')
	},
	// {
	// 	path: 'submitInfo',
	// 	meta: {
	// 		title: '查看'
	// 	},
	// 	component: () => import('../views/backstage/essayEvaluation/submitInfo.vue')
	// },

	{
		path: 'submitteInfo',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/essayEvaluation/submitteInfo.vue')
	},
	{
		path: 'submitState',
		meta: {
			title: 'submitState'
		},
		component: () => import('../views/backstage/essayEvaluation/submitState.vue')
	},
]
const districtManage = [
	//征文评审 => 区级管理
	{
		path: 'districtManage',
		meta: {
			title: '区级管理'
		},
		component: () => import('../views/backstage/essayEvaluation/districtManage.vue')
	},
	{
		path: 'schoolDetail',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/essayEvaluation/schoolDetail.vue')
	},
	{
		path: 'checkDistrictManage',
		meta: {
			title: '征文评审区级管理'
		},
		component: () => import('../views/backstage/essayEvaluation/checkDistrictManage.vue')
	},
	{
		path: 'deliverAnnouncement',
		meta: {
			title: '发布提交通知'
		},
		component: () => import('../views/backstage/essayEvaluation/deliverAnnouncement.vue')
	},
	{
		path: 'reviewManage',
		meta: {
			title: '征文评审'
		},
		component: () => import('../views/backstage/essayEvaluation/reviewManage.vue')
	},
	{
		path: 'IndividualScore',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/essayEvaluation/IndividualScore.vue')
	}
]

const schoolManage = [
	// 征文评审 => 学校管理
	{
		path: 'schoolManage',
		meta: {
			title: '学校管理'
		},
		component: () => import('../views/backstage/essayEvaluation/schoolManage.vue')
	},
	{
		path: 'processManage',
		meta: {
			title: '征文评审'
		},
		component: () => import('../views/backstage/essayEvaluation/processManage.vue')
	},
	{
		path: 'schoolDetail',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/essayEvaluation/schoolDetail.vue')
	},
	{
		path: 'submitteInfo',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/essayEvaluation/submitteInfo.vue')
	},

]
const statisticalQuery = [
	// 征文评审 => 统计查询
	{
		path: 'statisticalQuery',
		meta: {
			title: '统计查询'
		},
		component: () => import('../views/backstage/essayEvaluation/statisticalQuery.vue')
	}
]

const expertRating = [
	// 征文评审 => 专家评分
	{
		path: 'expertRating',
		meta: {
			title: '专家评分'
		},
		component: () => import('../views/backstage/essayEvaluation/expertRating.vue')
	},
	{
		path: 'reviewWorks',
		meta: {
			title: '专家待评审作品'
		},
		component: () => import('../views/backstage/essayEvaluation/reviewWorks.vue')
	},
	{
		path: 'IndividualRating',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/essayEvaluation/IndividualRating.vue')
	}
]

const mySubmittedAchievement = [
	//成果 => 我提交作品
	{
		path: 'mySubmittedAchievement',
		meta: {
			title: '个人提交'
		},
		component: () => import('../views/backstage/achievementEvaluation/mySubmitted.vue')
	},
	{
		path: 'submitteAppraisalAchievement',
		meta: {
			title: '提交参评作品'
		},
		component: () => import('../views/backstage/achievementEvaluation/submitteAppraisal.vue')
	},
	{
		path: 'submitInfoAchievement',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/achievementEvaluation/submitInfo.vue')
	},
	{
		path: 'submitStateAchievement',
		meta: {
			title: 'submitStateAchievement'
		},
		component: () => import('../views/backstage/achievementEvaluation/submitState.vue')
	},
	{
		path: 'submitteInfoAchievement',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/achievementEvaluation/submitteInfo.vue')
	},
]

const schoolManageAchievement = [
	// 成果评奖 => 学校管理
	{
		path: 'schoolManageAchievement',
		meta: {
			title: '学校管理'
		},
		component: () => import('../views/backstage/achievementEvaluation/schoolManage.vue')
	},
	{
		path: 'processManageAchievement',
		meta: {
			title: '成果评奖'
		},
		component: () => import('../views/backstage/achievementEvaluation/processManage.vue')
	},
	{
		path: 'schoolDetailAchievement',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/achievementEvaluation/schoolDetail.vue')
	},
	{
		path: 'submitteInfoAchievement',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/achievementEvaluation/submitteInfo.vue')
	},

]

const districtManageAchievement = [
	//成果评奖 => 区级管理
	{
		path: 'districtManageAchievement',
		meta: {
			title: '区级管理'
		},
		component: () => import('../views/backstage/achievementEvaluation/districtManage.vue')
	},
	{
		path: 'checkDistrictManageAchievement',
		meta: {
			title: '成果评奖区级管理'
		},
		component: () => import('../views/backstage/achievementEvaluation/checkDistrictManage.vue')
	},
	{
		path: 'schoolDetailAchievement',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/achievementEvaluation/schoolDetail.vue')
	},
	{
		path: 'deliverAnnouncementAchievement',
		meta: {
			title: '发布提交通知'
		},
		component: () => import('../views/backstage/achievementEvaluation/deliverAnnouncement.vue')
	},
	{
		path: 'reviewManageAchievement',
		meta: {
			title: '成果评奖'
		},
		component: () => import('../views/backstage/achievementEvaluation/reviewManage.vue')
	},
	{
		path: 'IndividualScoreAchievement',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/achievementEvaluation/IndividualScore.vue')
	},
	{
		path: 'submitteInfoAchievement',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/achievementEvaluation/submitteInfo.vue')
	},
]

const statisticalQueryAchievement = [
	// 成果评奖 => 评分统计
	{
		path: 'statisticalQueryAchievement',
		meta: {
			title: '评分统计'
		},
		component: () => import('../views/backstage/achievementEvaluation/statisticalQuery.vue')
	}
]

const expertRatingAchievement = [
	// 成果评奖 => 成果评分
	{
		path: 'expertRatingAchievement',
		meta: {
			title: '成果评分'
		},
		component: () => import('../views/backstage/achievementEvaluation/expertRating.vue')
	},
	{
		path: 'reviewWorksAchievement',
		meta: {
			title: '成果待评审作品'
		},
		component: () => import('../views/backstage/achievementEvaluation/reviewWorks.vue')
	},
	{
		path: 'IndividualRatingAchievement',
		meta: {
			title: '成果评审打分'
		},
		component: () => import('../views/backstage/achievementEvaluation/IndividualRating.vue')
	}
]

const mySubmittedIndividual = [
	//先进个人评奖 => 我提交作品
	{
		path: 'mySubmittedIndividual',
		meta: {
			title: '提交作品'
		},
		component: () => import('../views/backstage/individualEvaluation/mySubmitted.vue')
	},
	{
		path: 'submitteAppraisalIndividual',
		meta: {
			title: '提交参评作品'
		},
		component: () => import('../views/backstage/individualEvaluation/submitteAppraisal.vue')
	},
	{
		path: 'submitteInfoIndividual',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/individualEvaluation/submitteInfo.vue')
	},
	{
		path: 'submitStateIndividual',
		meta: {
			title: 'submitStateIndividual'
		},
		component: () => import('../views/backstage/individualEvaluation/submitState.vue')
	},
]

const schoolManageIndividual = [
	// 先进个人评奖 => 学校管理
	{
		path: 'schoolManageIndividual',
		meta: {
			title: '学校管理'
		},
		component: () => import('../views/backstage/individualEvaluation/schoolManage.vue')
	},
	{
		path: 'processManageIndividual',
		meta: {
			title: '先进个人评奖'
		},
		component: () => import('../views/backstage/individualEvaluation/processManage.vue')
	},
	{
		path: 'schoolDetailIndividual',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/individualEvaluation/schoolDetail.vue')
	},
	{
		path: 'submitteInfoIndividual',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/individualEvaluation/submitteInfo.vue')
	},

]

const districtManageIndividual = [
	//先进个人评奖 => 区级管理
	{
		path: 'districtManageIndividual',
		meta: {
			title: '区级管理'
		},
		component: () => import('../views/backstage/individualEvaluation/districtManage.vue')
	},
	{
		path: 'schoolDetailIndividual',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/individualEvaluation/schoolDetail.vue')
	},
	{
		path: 'checkDistrictManageIndividual',
		meta: {
			title: '先进个人评奖区级管理'
		},
		component: () => import('../views/backstage/individualEvaluation/checkDistrictManage.vue')
	},
	{
		path: 'deliverAnnouncementIndividual',
		meta: {
			title: '发布提交通知'
		},
		component: () => import('../views/backstage/individualEvaluation/deliverAnnouncement.vue')
	},
	{
		path: 'reviewManageIndividual',
		meta: {
			title: '先进个人评奖'
		},
		component: () => import('../views/backstage/individualEvaluation/reviewManage.vue')
	},
	{
		path: 'IndividualScoreIndividual',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/individualEvaluation/IndividualScore.vue')
	},
	{
		path: 'submitteInfoIndividual',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/individualEvaluation/submitteInfo.vue')
	},
]

const statisticalQueryIndividual = [
	// 先进个人评奖 => 统计查询
	{
		path: 'statisticalQueryIndividual',
		meta: {
			title: '统计查询'
		},
		component: () => import('../views/backstage/individualEvaluation/statisticalQuery.vue')
	}
]

const expertRatingIndividual = [
	// 先进个人评奖 => 先进个人评分
	{
		path: 'expertRatingIndividual',
		meta: {
			title: '专家评分'
		},
		component: () => import('../views/backstage/individualEvaluation/expertRating.vue')
	},
	{
		path: 'reviewWorksIndividual',
		meta: {
			title: '专家待评审作品'
		},
		component: () => import('../views/backstage/individualEvaluation/reviewWorks.vue')
	},
	{
		path: 'IndividualRatingIndividual',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/individualEvaluation/IndividualRating.vue')
	}
]

const mySubmittedCollective = [
	//集体 => 我提交作品
	{
		path: 'mySubmittedCollective',
		meta: {
			title: '提交作品'
		},
		component: () => import('../views/backstage/collectiveEvaluation/mySubmitted.vue')
	},
	{
		path: 'submitteAppraisalCollective',
		meta: {
			title: '提交参评作品'
		},
		component: () => import('../views/backstage/collectiveEvaluation/submitteAppraisal.vue')
	},
	{
		path: 'submitStateCollective',
		meta: {
			title: 'submitStateCollective'
		},
		component: () => import('../views/backstage/collectiveEvaluation/submitState.vue')
	},
	{
		path: 'submitteInfoCollective',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/collectiveEvaluation/submitteInfo.vue')
	},
]

const schoolManageCollective = [
	// 集体 => 学校管理
	{
		path: 'schoolManageCollective',
		meta: {
			title: '学校管理'
		},
		component: () => import('../views/backstage/collectiveEvaluation/schoolManage.vue')
	},
	{
		path: 'processManageCollective',
		meta: {
			title: '先进集体评奖'
		},
		component: () => import('../views/backstage/collectiveEvaluation/processManage.vue')
	},
	{
		path: 'schoolDetailCollective',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/collectiveEvaluation/schoolDetail.vue')
	},
	{
		path: 'submitteInfoCollective',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/collectiveEvaluation/submitteInfo.vue')
	},

]

const districtManageCollective = [
	//集体评奖 => 区级管理
	{
		path: 'districtManageCollective',
		meta: {
			title: '区级管理'
		},
		component: () => import('../views/backstage/collectiveEvaluation/districtManage.vue')
	},
	{
		path: 'schoolDetailCollective',
		meta: {
			title: '审核'
		},
		component: () => import('../views/backstage/collectiveEvaluation/schoolDetail.vue')
	},
	{
		path: 'checkDistrictManageCollective',
		meta: {
			title: '征文评审区级管理'
		},
		component: () => import('../views/backstage/collectiveEvaluation/checkDistrictManage.vue')
	},
	{
		path: 'deliverAnnouncementCollective',
		meta: {
			title: '发布提交通知'
		},
		component: () => import('../views/backstage/collectiveEvaluation/deliverAnnouncement.vue')
	},
	{
		path: 'reviewManageCollective',
		meta: {
			title: '先进集体评奖'
		},
		component: () => import('../views/backstage/collectiveEvaluation/reviewManage.vue')
	},
	{
		path: 'IndividualScoreCollective',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/collectiveEvaluation/IndividualScore.vue')
	},
	{
		path: 'submitteInfoCollective',
		meta: {
			title: '查看'
		},
		component: () => import('../views/backstage/collectiveEvaluation/submitteInfo.vue')
	},
]

const statisticalQueryCollective = [
	// 集体 => 统计查询
	{
		path: 'statisticalQueryCollective',
		meta: {
			title: '统计查询'
		},
		component: () => import('../views/backstage/collectiveEvaluation/statisticalQuery.vue')
	}
]

const expertRatingCollective = [
	// 集体 => 专家评分
	{
		path: 'expertRatingCollective',
		meta: {
			title: '专家评分'
		},
		component: () => import('../views/backstage/collectiveEvaluation/expertRating.vue')
	},
	{
		path: 'reviewWorksCollective',
		meta: {
			title: '专家待评审作品'
		},
		component: () => import('../views/backstage/collectiveEvaluation/reviewWorks.vue')
	},
	{
		path: 'IndividualRatingCollective',
		meta: {
			title: '专家评审打分'
		},
		component: () => import('../views/backstage/collectiveEvaluation/IndividualRating.vue')
	}
]


// 路由映射关系
const ruleMapping = {
	//集体
	mySubmittedCollective,
	schoolManageCollective,
	districtManageCollective,
	statisticalQueryCollective,
	expertRatingCollective,
	//个人
	mySubmittedIndividual,
	schoolManageIndividual,
	districtManageIndividual,
	statisticalQueryIndividual,
	expertRatingIndividual,
	//成果
	districtManageAchievement,
	statisticalQueryAchievement,
	expertRatingAchievement,
	mySubmittedAchievement,
	schoolManageAchievement,
	//征文评审
	districtManage,
	statisticalQuery,
	expertRating,
	mySubmitted,
	schoolManage,
	topicsList: topicsDeclaration,
	schoolTopicReviewList: schoolTopicList,
	areaReviewList: areaTopicList,
	declarationSummaryStatistics,
	expertReviewList: topicList,
	expertScoreList,
	proposedProject,
	approvedProject,
	userManagementList,
	articleManagement,
	areaManagement,
	unitManagement,
	roleAuthorization,
	platformInformationMaintenance,
	// 课题管理
	myTopic,
	topicSummary,
	openReview,
	midtermReview,
	concludingApplication,
	concludingReview,
	topicManageExpertReviewList,
	quasiConcluding,
	finishedTopic,
	topicChange,
	topicStat,
	topicManageReviewList,
	//科研资源列表
	scientificResource,
}

const routes = [{
		path: "/",
		redirect: "/home",
	},
	{
		path: "/home",
		component: Home,
		redirect: '/index',
		children: [{
				path: "/index",
				component: () => import("../views/frontDesk/index.vue"),
			},
			{
				path: "/researchDynamics",
				component: () => import("../views/frontDesk/researchDynamics.vue"),

			},
			// 课题研究
			{
				path: "/subjectResearch",
				component: () => import("../views/frontDesk/subjectResearch/subjectResearch.vue"),
			},
			// 课题研究-列表
			{
				path: "/subjectResearchList",
				component: () => import("../views/frontDesk/subjectResearch/subjectResearchList.vue"),
			},
			// 课题研究-详情
			{
				path: "/subjectResearchDetail",
				component: () => import("../views/frontDesk/subjectResearch/subjectResearchDetail.vue"),
			},
			{
				path: "/researchResults",
				component: () => import("../views/frontDesk/researchResults/researchResults.vue"),
			},
			{
				path: "/papersList",
				component: () => import("../views/frontDesk/researchResults/papersList.vue"),
			},
			{
				path: "/resultsDetails",
				component: () => import("../views/frontDesk/researchResults/resultsDetails.vue"),
			},
			{
				path: "/searchList",
				component: () => import("../views/frontDesk/researchResults/searchList.vue"),
			},
			{
				path: "/projectManagement",
				component: () => import("../views/frontDesk/projectManagement.vue"),
			},
			{
				path: "/researchResources",
				component: () => import("../views/frontDesk/researchResources.vue"),
			},
			{
				path: "/publicList/:type",
				component: () => import("../views/frontDesk/common/publicList.vue"),
			},
			{
				path: "/publicDetails/:id",
				component: () => import("../views/frontDesk/common/publicDetails.vue"),
			},
			{
				path: "/searchValueList",
				component: () => import("../views/frontDesk/searchValueList.vue"),
			},
		]
	},
	{
		path: "/backstage",
		component: () => import("../views/backstage/home.vue"),
		meta: {
			title: '后台首页'
		},
		redirect: '/backstage/index',
		children: [
			// 后台首页
			{
				path: '/backstage/index',
				meta: {
					title: '后台首页'
				},
				component: () => import('../views/backstage/index.vue')
			},
		]
	},
	{
		path: '/myCenter',
		component: () => import('../views/myCenter.vue')
	},
	{
		path: '*',
		component: () => import('../views/NotFound.vue')
	}
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.path.includes('backstage')) {
		if (sessionStorage.getItem('token')) {
			next()
		} else {
			Element.Message.error('请登录！')
			next('/index')
		}
	} else {
		next()
	}
})


export function initDynamicRoutes() {
	let curRoutes = router.options.routes
	console.log(curRoutes);
	const menuList = JSON.parse(sessionStorage.getItem('menuList'))
	menuList.forEach(item => {
		if (item.children) { //该菜单有子级
			console.log(item.children);
			item.children.forEach(item1 => {
				
				
				const temp = ruleMapping[item1.path]
			
					curRoutes[2].children = [...curRoutes[2].children, ...temp]
				
			
				
				
			})
		} else { //该菜单无子级
			if (item.path === 'index') {
				return 
			}
			const temp = ruleMapping[item.path]
			
				curRoutes[2].children = [...curRoutes[2].children, ...temp]
			
		
		}
	})
	
	router.addRoutes(curRoutes)
}

if (sessionStorage.getItem('menuList')) {
	initDynamicRoutes()
}

export default router;
